import React from "react";
import { Link } from "react-router-dom";

export default function ApplicationsHome() {
  return (
    <section className="space-y-6">
      <header className="max-w-2xl">
        <h2 className="text-2xl sm:text-3xl font-semibold text-amber-100 mb-2">
          Choose a form category
        </h2>
        <p className="text-sm text-amber-200/80">
          Use this hub to submit staff reports, general feedback, or applications for staff and leadership
          roles in Howling Hills.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Link
          to="/howling-hills/applications/report-staff"
          className="block rounded-xl border border-amber-800/70 bg-black/40 p-4 hover:border-amber-500/80 hover:bg-amber-900/20 transition-colors"
        >
          <h3 className="text-lg font-semibold text-amber-100 mb-1">Report a Staff Member</h3>
          <p className="text-xs text-amber-200/80">
            Safely report concerns about staff behavior. Routed privately to Admin, Lead Admin or Edith
            respectively.
          </p>
        </Link>

        <Link
          to="/howling-hills/applications/feedback"
          className="block rounded-xl border border-amber-800/70 bg-black/40 p-4 hover:border-amber-500/80 hover:bg-amber-900/20 transition-colors"
        >
          <h3 className="text-lg font-semibold text-amber-100 mb-1">Feedback Forms</h3>
          <p className="text-xs text-amber-200/80">
            Share HUD, build, general, or backer feedback. Anonymous submission is available here.
          </p>
        </Link>

        <Link
          to="/howling-hills/applications/applications"
          className="block rounded-xl border border-amber-800/70 bg-black/40 p-4 hover:border-amber-500/80 hover:bg-amber-900/20 transition-colors"
        >
          <h3 className="text-lg font-semibold text-amber-100 mb-1">Application Forms</h3>
          <p className="text-xs text-amber-200/80">
            Staff, Lead, VIP Waitlist, Item creation applications can all be found here. Please note: To apply for
            Admin, you must be a current member of staff.
          </p>
        </Link>
      </div>
    </section>
  );
}
